import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import VolverLink from './VolverLink.jsx';
import Titulo from './Titulo.jsx';
import NuevaEntidad from './NuevaEntidad.jsx';
import SubTitulo from './SubTitulo.jsx';
import Table from './Table.jsx';
import PaginaLink from './PaginaLink.jsx';
import Filtros from './Filtros/Filtros';


class VistaInstanciaParametro extends Component {

    constructor(props) {
        super(props);
        this.state = {
            verSoloRegistrosActivos: true,
            paginaBusqueda: ""
        }
        this._dispatchToken = undefined;
        this.vistaRegistros = this.vistaRegistros.bind(this);
        this.buscarPagina = this.buscarPagina.bind(this);
        this.mostrarActivos = this.mostrarActivos.bind(this);
    }

    componentWillReceiveProps() {
        this.setState({ paginaBusqueda: "" })
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        this.props.actions.getDataVistaInstanciaParametro(id, this.props.currentScope);
        this.props.actions.getEntidadRelacionada();
    }

    componentWillUnmount() {
        this.props.actions.resetState();
    }

    vistaRegistros() {
        if (this.props.data.paginaActual && this.props.data.paginaActual != 1) {
            Promise.resolve(this.props.irAPagina(1)).then(function (value) {
                this.setState({ verSoloRegistrosActivos: !this.state.verSoloRegistrosActivos })
            });
        }
        this.setState({ verSoloRegistrosActivos: !this.state.verSoloRegistrosActivos })
    }

    buscarPagina(value) {
        let regExp = /^[1-9][0-9]*$/g;
        let result = regExp.test(value);

        //Se puede ingresar valores a partir de 1 a infinito, se permite el valor '' para poder reinicializarlo si se borra
        //el valor ingresado, de todas formas el botón de "buscar página" no ejecuta acción alguna si valor = ""
        if (result || value == '') {
            this.setState({ paginaBusqueda: value });
        }
    }

    validarPagina(inputPaginaLength, inputPagina, cantidadPaginas) {
        return inputPaginaLength > 0 && inputPagina <= cantidadPaginas;
    }

    mostrarActivos(mostrarActivos, paginaActual, arrayFiltrosDefinitivo){
        this.setState({ verSoloRegistrosActivos: !this.state.verSoloRegistrosActivos });
        this.props.actions.mostrarActivos(mostrarActivos, paginaActual, arrayFiltrosDefinitivo);
    }

    render() {
        let props = this.props.data;

        if (this.props.atlas.rutearNuevaInstancia == true) {
            return <Redirect push to={this.props.atlas.rutaNuevaInstancia} />;
        }

        if (this.props.atlas.rutearEdicionInstancia == true) {
            return <Redirect push to={this.props.atlas.rutaEdicionInstancia} />;
        }

        if (props.data.loading) {
            return <div className="loading"> Loading &#8230;</div>;
        }

        if (props.data.entidad) {
            return (<div className="container-fluid atlas">
                <VolverLink />
                <Titulo entidad={props.data.entidad} soloLectura={props.data.entidad.Solo_Lectura}/>
                {props.data.entidad.Solo_Lectura ? 
                null
                :
                <NuevaEntidad crearNuevaEntidadInstancia={this.props.actions.crearNuevaEntidadInstancia}
                    entidad={props.data.entidad} />
                }
                <div className='check-registros-activos-total VistaInstanciaParametro-Filtros-Marign-Top'>
                    <div className="contenedorCheckboxRegistrosVigentes default-checkbox">
                        <input disabled={false} id={"check-activo-parametros-total"} type="checkbox" checked={this.state.verSoloRegistrosActivos} onChange={() => this.mostrarActivos(!this.state.verSoloRegistrosActivos, 1, props.data.arrayFiltrosDefinitivo)} />
                        <label className={"label-primary " + (true ? "" : "disabledGrey")} htmlFor={"check-activo-parametros-total"}></label>
                    </div>
                    <label className="label-primary labelCheckAvisoViaje" htmlFor={"check-activo-parametros-total"}><p>Visualizar sólo registros vigentes</p></label>
                </div>
                <Filtros data={props.data} actions={this.props.actions} registrosActivos={this.state.verSoloRegistrosActivos} arrayFiltrosDefinitivoLength={props.data.arrayFiltrosDefinitivo?.length}/>
                <SubTitulo entidad={props.data.entidad} />
                <Table propiedadInstancia={this.state.verSoloRegistrosActivos ? props.data.propiedadInstancia.filter(p => p.Activo) : props.data.propiedadInstancia}
                    entidadInstancia={this.state.verSoloRegistrosActivos ? props.data.entidadInstancia.filter(e => e.Activo) : props.data.entidadInstancia}
                    atlas={this.props.atlas}
                    setearEntidadInstancia={this.props.actions.setearEntidadInstancia}
                    cantidadRegistrosEntidad={props.data.cantidadRegistrosEntidad}
                    propiedadesHeaderGrilla={props.data.propiedadesVisibleEnGrilla}
                    soloLectura={props.data.entidad.Solo_Lectura} />
                {props.data.cantidadPaginas > 1 ?
                    <div>
                        <PaginaLink changePaginaAnterior={this.props.actions.changePaginaAnterior}
                            changePaginaSiguiente={this.props.actions.changePaginaSiguiente}
                            registrosActualesEnPagina={props.data.registrosActualesEnPagina}
                            cantidadRegistrosEntidad={props.data.cantidadRegistrosEntidad}
                            cantidadPaginas={props.data.cantidadPaginas}
                            paginaActual={props.data.paginaActual}
                            irAPagina={this.props.actions.irAPagina}
                            setearInputPagina={this.buscarPagina}
                            registrosActivos={this.state.verSoloRegistrosActivos}
                            arrayFiltrosDefinitivo={props.data.arrayFiltrosDefinitivo}
                        />
                        <div className="col-xs-5"></div>
                        <div className="col-xs-3">
                            <input type='text' value={this.state.paginaBusqueda} onChange={(e) => this.buscarPagina(e.target.value)} className="form-control inputPageNumber"></input>
                            <label>&nbsp;&nbsp;&nbsp;</label>
                            <button onClick={() => this.validarPagina(this.state.paginaBusqueda.length, this.state.paginaBusqueda, props.data.cantidadPaginas) ? this.props.actions.irAPagina(this.state.paginaBusqueda, this.state.verSoloRegistrosActivos, props.data.arrayFiltrosDefinitivo) : null} className="btn-orange right-separator-xs">Ir a página</button>
                        </div>
                        <div className="col-xs-4"></div>
                    </div>
                    : null
                }
            </div>);
        }
        else {
            return null;
        }
    }
}

export default VistaInstanciaParametro;